import React, { Dispatch, SetStateAction } from 'react';

import TableHead from 'components/data-visualization/Table/DropdownHead';
import TableBody from 'components/data-visualization/Table/Body';
import TableRow from './TableRow';
import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';

import { ConcertsTable as Table } from './styles';

import { IMetric } from 'maps/metrics';
import { ICountryFlagProps } from 'types/shared';
import { IConcert } from './types';
import { Headers } from 'components/Concerts/utils/getMenuItems';
import { TableHeader } from 'components/Concerts/utils/getTableHeaders';

interface ITableProps {
  changeSortMetric: (metric: IMetric) => void;
  concerts: IConcert[];
  countries: ICountryFlagProps[];
  notSortable: Set<string>;
  sortMetric: IMetric | undefined;
  sortOrder: string;
  setSortMetric: Dispatch<SetStateAction<IMetric | undefined>>;
  setSortOrder: Dispatch<SetStateAction<string>>;
  tableHeaders: TableHeader[];
  tableHeadItems: Headers;
  tableName: string;
  withChangeMetric: Set<string>;
}

const ConcertsTable: React.FC<ITableProps> = ({
  changeSortMetric,
  concerts,
  countries,
  notSortable,
  sortMetric,
  sortOrder,
  setSortMetric,
  setSortOrder,
  tableHeaders,
  tableHeadItems,
  tableName,
  withChangeMetric,
}) => (
  <Table cellSpacing="0" cellPadding="0">
    <TableHead
      sortMetric={sortMetric}
      sortOrder={sortOrder}
      setSortMetric={setSortMetric}
      setSortOrder={setSortOrder}
      changeSortMetric={changeSortMetric}
      headers={tableHeaders}
      withChangeMetric={withChangeMetric}
      tableName={tableName}
      predefinedMenuItems={tableHeadItems}
      notSortable={notSortable}
    />
    <TableBody>
      {concerts && concerts.length > 0 ? (
        concerts.map((item: IConcert, id: number) => {
          const countryMetadata = countries.find(
            (country: ICountryFlagProps) =>
              country?.displayName === item?.countryName
          );
          return (
            <TableRow
              {...item}
              countryMetadata={countryMetadata}
              key={`${item?.tourName}-${item?.date}-${id}`}
            />
          );
        })
      ) : (
        <TableLoader columnCount={tableHeaders.length} />
      )}
    </TableBody>
  </Table>
);

export default ConcertsTable;
